<div
  class="sub-menu"
  role="menu">

  <div class="container-lg">
    <header class="sub-menu__header">
      <button
        type="button"
        class="sub-menu__back qs-btn qs-btn--tiny qs-btn--text-only qs-btn--icon qs-btn--icon-arrow-backward d-block d-md-none"
        tabindex="-1"
        (click)="toggleSubNav(null)">

        Back
      </button>

      <p class="sub-menu__title">
        {{ title$() }}
      </p>

      <div class="sub-menu__links">
        <app-new-ctas
          [config$]="links$()"
          (click)="closeMainNav()" />
      </div>
    </header>

    <app-strapi-rich-text-block
      class="sub-menu__desc"
      [config$]="description$()" />

    <ng-content />
  </div>
</div>
